import { useMemo } from 'react';

const FORCED_EXPERIMENT_QUERY_PARAM = 'opt_experiment';

export const useForcedOptimizelyExperimentQueryMap = (): Record<string, string> => {
  return useMemo(() => {
    const map: Record<string, string> = {};

    try {
      const params = new URLSearchParams(window.location.search);
      for (const value of params.getAll(FORCED_EXPERIMENT_QUERY_PARAM)) {
        const [experimentId, variationId] = value.split(',');
        if (experimentId && variationId) {
          map[experimentId] = variationId;
        }
      }
    } catch {
      // silently fail
    }

    return map;
  }, []);
};
